// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-consultation-bc {
  padding: 2rem;
}

.consultation-header h2 {
  color: #2C3948;
  font-size: 2.4rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.status-info {
  font-weight: 500;
  border-left: 4px solid currentColor;
}

.pending-rang {
  text-align: center;
  padding: 4rem 2rem;
  color: #6B7280;
  font-size: 1.6rem;
}

.financial-options {
  margin-bottom: 2rem;
}

.info-text {
  color: #6B7280;
  font-size: 1.4rem;
  margin-top: 1rem;
  font-style: italic;
}

/* Styles pour le tableau d'articles */
.articles-table-container {
  /* margin-top: 2rem;
  padding: 2rem;
  background-color: #F9FAFB;
  border-radius: 12px;
  border: 1px solid #E5E7EB; */
}

.articles-table-container h4 {
  color: #2C3948;
  font-size: 1.8rem;
  font-weight: 600;
}

.articles-table-wrapper {
  overflow-x: auto;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  margin-bottom: 2rem;
}

.articles-table-wrapper .add-article-button {
  margin: 1rem;
}

.articles-table-footer {
  padding: 2rem;
  border-top: 1px solid #E5E7EB;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
}

.footer-actions {
  display: flex;
  gap: 1rem;
}

.footer-summary {
  text-align: right;
}

.footer-summary h4 {
  margin: 0 0 0.5rem 0;
  color: #2C3948;
  font-size: 1.4rem;
}

.total-section p {
  margin: 0;
  font-weight: 700;
  font-size: 1.8rem;
}

/* Styles spécifiques par colonne - MISE À JOUR */
.article-number {
  text-align: center;
  color: #2C3948;
  width: 8%;
  font-size: 1.3rem;
}

.article-description {
  width: 50%; /* Encore plus large - 4 fois plus large qu'avant */
  padding-right: 2rem;
}

.article-name {
  color: #2C3948;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
}

.article-code {
  color: #6B7280;
  font-size: 1.2rem;
  font-style: italic;
  line-height: 1.3;
}

.article-unit {
  text-align: center;
  width: 8%;
}

.article-quantity {
  text-align: center;
  color: #2C3948;
  font-weight: 600;
  width: 6%;
}

.article-price {
  text-align: right !important; /* Force l'alignement à droite */
  color: #2C3948;
  font-weight: 500;
  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */
}

.article-total {
  text-align: right !important; /* Force l'alignement à droite */
  font-weight: 700;
  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */
}

.price-cell {
  text-align: right !important; /* Force l'alignement à droite */
  color: #2C3948;
  font-weight: 500;
  padding-right: 1rem;
}

.total-cell {
  text-align: right !important; /* Force l'alignement à droite */
  font-weight: 700;
  color: #DA7027;
  padding-right: 1rem;
}

.article-actions {
  text-align: center;
  width: 8%; /* Plus large pour correspondre au wireframe */
  position: relative;
}


/* Styles pour le total */
.total-row {
  background-color: #F8F9FA !important;
  border-top: 3px solid #DA7027 !important;
  font-weight: 600;
}

.total-row:hover {
  background-color: #F8F9FA !important;
}

.total-row td {
  border-bottom: none !important;
  padding: 2rem 1rem !important;
}

.total-label {
  text-align: right;
  color: #2C3948;
  font-size: 1.6rem;
  font-weight: 700;
}

.total-row .article-total {
  color: #DA7027;
  font-size: 1.8rem;
  font-weight: 700;
}

.financial-choice {
  text-align: center;
  padding: 3rem 2rem;
  border: 2px dashed #E5E7EB;
  border-radius: 0.8rem;
  background-color: #F8F9FA;
}

.financial-choice h4 {
  color: #2C3948;
  font-size: 1.8rem;
  margin-bottom: 2rem;
}

.choice-buttons {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.choice-buttons .button {
  min-width: 250px;
}

.financial-choice .info-text {
  color: #6B7280;
  font-size: 1.4rem;
  line-height: 1.5;
  max-width: 600px;
  margin: 0 auto;
}

.catalogue-mode {
  background-color: #F8F9FA;
  padding: 2rem;
  border-radius: 0.8rem;
  border-left: 4px solid #DA7027;
}

.prestataire-mode {
  background-color: rgba(218, 112, 39, 0.15);
  padding: 2rem;
  border-radius: 0.8rem;
  border-left: 4px solid #DA7027;
}

.prestataire-mode .info-message h4 {
  color: #1E40AF;
  font-size: 1.6rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.prestataire-mode .info-message p {
  color: #1E3A8A;
  font-size: 1.4rem;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.financial-options {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.add-more-articles-btn {
  width: 100%;
  padding: 1rem;
  background: none;
  border: 2px dashed #E5E7EB;
  border-radius: 0.4rem;
  color: #6B7280;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.add-more-articles-btn:hover {
  border-color: #DA7027;
  color: #DA7027;
  background-color: rgba(218, 112, 39, 0.05);
}

/* Ajoutez ces styles dans votre fichier ConsultationBC.css */
.demande-envoyee-message {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background-color: #f8f9fa;
  border-left: 4px solid #DA7027;
  border-radius: 8px;
  margin: 16px 0;
}

.info-icon {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 4px;
}

.message-content h4 {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.message-content p {
  margin: 0 0 12px 0;
  color: #6c757d;
  line-height: 1.5;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6c757d;
  font-style: italic;
}

.status-dot {
  width: 8px;
  height: 8px;
  background-color: #ffc107;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.acheteur-no-rights-message {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin: 1rem 0;
  text-align: center;
}

.acheteur-no-rights-message p {
  margin: 0;
  color: #856404;
  font-weight: 500;
  font-size: 1rem;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.changer-de-mode {
  margin-bottom: 2rem;
}

/* Styles pour les prestataires remplissant les articles transférés */
.prestataire-fill-articles {
  padding: 0; /* Pas de padding pour réutiliser les classes existantes */
}

.prestataire-instructions {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: rgba(218, 112, 39, 0.15);
  border-radius: 8px;
  border-left: 4px solid #DA7027;
}

.prestataire-instructions h4 {
  margin-bottom: 0.5rem;
  font-size: 1.6rem;
}

.prestataire-instructions p {
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.5;
}

.prestataire-no-access {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-style: italic;
}

/* S'assurer que les classes existantes fonctionnent pour les prestataires */
.prestataire-fill-articles .articles-table-container,
.prestataire-fill-articles .articles-table-wrapper,
.prestataire-fill-articles .add-article-button,
.prestataire-fill-articles .articles-actions,
.prestataire-fill-articles .total-section,
.prestataire-fill-articles .financial-choice,
.prestataire-fill-articles .choice-buttons {
  /* Hériter de tous les styles existants */
}

.action-buttons-group {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-start;
}

/* Conteneur horizontal pour les boutons d'action */
.action-buttons-row {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* Conteneur pour le bouton de notification et le message */
.notification-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

/* Liste des notifications envoyées (pour plusieurs notifications) */
.notifications-sent-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

/* Message indiquant qu'une notification a déjà été envoyée (sous le bouton) */
.notification-sent-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #10b981;
  font-size: 1.2rem;
  font-weight: 500;
}

.notification-sent-info .notification-sent-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  background-color: #10b981;
  color: white;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: bold;
  flex-shrink: 0;
}

/* Message indiquant qu'une notification a déjà été envoyée (ancien style - conservé pour compatibilité) */
.notification-sent-message {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  background-color: #d1fae5;
  border: 1px solid #10b981;
  border-radius: 8px;
  color: #065f46;
  font-size: 1.4rem;
  font-weight: 500;
}

.notification-sent-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background-color: #10b981;
  color: white;
  border-radius: 50%;
  font-size: 1.2rem;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/composants/ConsultationBC/ConsultationBC.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;;;;8BAI4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU,EAAE,mDAAmD;EAC/D,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,cAAc;EACd,gBAAgB;EAChB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,gBAAgB;EAChB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,8CAA8C;EACzD,kBAAkB;AACpB;;;AAGA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,UAAU,EAAE,0DAA0D;AACxE;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;;;;;;;EAOE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0GAA0G;AAC1G;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".tab-consultation-bc {\n  padding: 2rem;\n}\n\n.consultation-header h2 {\n  color: #2C3948;\n  font-size: 2.4rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.status-info {\n  font-weight: 500;\n  border-left: 4px solid currentColor;\n}\n\n.pending-rang {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #6B7280;\n  font-size: 1.6rem;\n}\n\n.financial-options {\n  margin-bottom: 2rem;\n}\n\n.info-text {\n  color: #6B7280;\n  font-size: 1.4rem;\n  margin-top: 1rem;\n  font-style: italic;\n}\n\n/* Styles pour le tableau d'articles */\n.articles-table-container {\n  /* margin-top: 2rem;\n  padding: 2rem;\n  background-color: #F9FAFB;\n  border-radius: 12px;\n  border: 1px solid #E5E7EB; */\n}\n\n.articles-table-container h4 {\n  color: #2C3948;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.articles-table-wrapper {\n  overflow-x: auto;\n  background-color: white;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  margin-bottom: 2rem;\n}\n\n.articles-table-wrapper .add-article-button {\n  margin: 1rem;\n}\n\n.articles-table-footer {\n  padding: 2rem;\n  border-top: 1px solid #E5E7EB;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1.5rem;\n}\n\n.footer-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-summary {\n  text-align: right;\n}\n\n.footer-summary h4 {\n  margin: 0 0 0.5rem 0;\n  color: #2C3948;\n  font-size: 1.4rem;\n}\n\n.total-section p {\n  margin: 0;\n  font-weight: 700;\n  font-size: 1.8rem;\n}\n\n/* Styles spécifiques par colonne - MISE À JOUR */\n.article-number {\n  text-align: center;\n  color: #2C3948;\n  width: 8%;\n  font-size: 1.3rem;\n}\n\n.article-description {\n  width: 50%; /* Encore plus large - 4 fois plus large qu'avant */\n  padding-right: 2rem;\n}\n\n.article-name {\n  color: #2C3948;\n  font-weight: 600;\n  line-height: 1.4;\n  margin-bottom: 0.8rem;\n  font-size: 1.4rem;\n}\n\n.article-code {\n  color: #6B7280;\n  font-size: 1.2rem;\n  font-style: italic;\n  line-height: 1.3;\n}\n\n.article-unit {\n  text-align: center;\n  width: 8%;\n}\n\n.article-quantity {\n  text-align: center;\n  color: #2C3948;\n  font-weight: 600;\n  width: 6%;\n}\n\n.article-price {\n  text-align: right !important; /* Force l'alignement à droite */\n  color: #2C3948;\n  font-weight: 500;\n  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */\n}\n\n.article-total {\n  text-align: right !important; /* Force l'alignement à droite */\n  font-weight: 700;\n  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */\n}\n\n.price-cell {\n  text-align: right !important; /* Force l'alignement à droite */\n  color: #2C3948;\n  font-weight: 500;\n  padding-right: 1rem;\n}\n\n.total-cell {\n  text-align: right !important; /* Force l'alignement à droite */\n  font-weight: 700;\n  color: #DA7027;\n  padding-right: 1rem;\n}\n\n.article-actions {\n  text-align: center;\n  width: 8%; /* Plus large pour correspondre au wireframe */\n  position: relative;\n}\n\n\n/* Styles pour le total */\n.total-row {\n  background-color: #F8F9FA !important;\n  border-top: 3px solid #DA7027 !important;\n  font-weight: 600;\n}\n\n.total-row:hover {\n  background-color: #F8F9FA !important;\n}\n\n.total-row td {\n  border-bottom: none !important;\n  padding: 2rem 1rem !important;\n}\n\n.total-label {\n  text-align: right;\n  color: #2C3948;\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n.total-row .article-total {\n  color: #DA7027;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.financial-choice {\n  text-align: center;\n  padding: 3rem 2rem;\n  border: 2px dashed #E5E7EB;\n  border-radius: 0.8rem;\n  background-color: #F8F9FA;\n}\n\n.financial-choice h4 {\n  color: #2C3948;\n  font-size: 1.8rem;\n  margin-bottom: 2rem;\n}\n\n.choice-buttons {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.choice-buttons .button {\n  min-width: 250px;\n}\n\n.financial-choice .info-text {\n  color: #6B7280;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.catalogue-mode {\n  background-color: #F8F9FA;\n  padding: 2rem;\n  border-radius: 0.8rem;\n  border-left: 4px solid #DA7027;\n}\n\n.prestataire-mode {\n  background-color: rgba(218, 112, 39, 0.15);\n  padding: 2rem;\n  border-radius: 0.8rem;\n  border-left: 4px solid #DA7027;\n}\n\n.prestataire-mode .info-message h4 {\n  color: #1E40AF;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.prestataire-mode .info-message p {\n  color: #1E3A8A;\n  font-size: 1.4rem;\n  margin-bottom: 2rem;\n  line-height: 1.5;\n}\n\n.financial-options {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.add-more-articles-btn {\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: 2px dashed #E5E7EB;\n  border-radius: 0.4rem;\n  color: #6B7280;\n  cursor: pointer;\n  font-size: 1.4rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.add-more-articles-btn:hover {\n  border-color: #DA7027;\n  color: #DA7027;\n  background-color: rgba(218, 112, 39, 0.05);\n}\n\n/* Ajoutez ces styles dans votre fichier ConsultationBC.css */\n.demande-envoyee-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-left: 4px solid #DA7027;\n  border-radius: 8px;\n  margin: 16px 0;\n}\n\n.info-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.message-content h4 {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.message-content p {\n  margin: 0 0 12px 0;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #ffc107;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.acheteur-no-rights-message {\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 8px;\n  padding: 1rem 1.5rem;\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.acheteur-no-rights-message p {\n  margin: 0;\n  color: #856404;\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.changer-de-mode {\n  margin-bottom: 2rem;\n}\n\n/* Styles pour les prestataires remplissant les articles transférés */\n.prestataire-fill-articles {\n  padding: 0; /* Pas de padding pour réutiliser les classes existantes */\n}\n\n.prestataire-instructions {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background-color: rgba(218, 112, 39, 0.15);\n  border-radius: 8px;\n  border-left: 4px solid #DA7027;\n}\n\n.prestataire-instructions h4 {\n  margin-bottom: 0.5rem;\n  font-size: 1.6rem;\n}\n\n.prestataire-instructions p {\n  margin: 0;\n  font-size: 1.4rem;\n  line-height: 1.5;\n}\n\n.prestataire-no-access {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* S'assurer que les classes existantes fonctionnent pour les prestataires */\n.prestataire-fill-articles .articles-table-container,\n.prestataire-fill-articles .articles-table-wrapper,\n.prestataire-fill-articles .add-article-button,\n.prestataire-fill-articles .articles-actions,\n.prestataire-fill-articles .total-section,\n.prestataire-fill-articles .financial-choice,\n.prestataire-fill-articles .choice-buttons {\n  /* Hériter de tous les styles existants */\n}\n\n.action-buttons-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  align-items: flex-start;\n}\n\n/* Conteneur horizontal pour les boutons d'action */\n.action-buttons-row {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* Conteneur pour le bouton de notification et le message */\n.notification-button-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Liste des notifications envoyées (pour plusieurs notifications) */\n.notifications-sent-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n/* Message indiquant qu'une notification a déjà été envoyée (sous le bouton) */\n.notification-sent-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #10b981;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n.notification-sent-info .notification-sent-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  background-color: #10b981;\n  color: white;\n  border-radius: 50%;\n  font-size: 1rem;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n/* Message indiquant qu'une notification a déjà été envoyée (ancien style - conservé pour compatibilité) */\n.notification-sent-message {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 1rem 1.5rem;\n  background-color: #d1fae5;\n  border: 1px solid #10b981;\n  border-radius: 8px;\n  color: #065f46;\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.notification-sent-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  background-color: #10b981;\n  color: white;\n  border-radius: 50%;\n  font-size: 1.2rem;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
